window.preloadImages = function(callback,progressCallback){
	var preloadImages = $('.js-bg-preload, .js-image-preload'),
		numRemaining = preloadImages.length,
		closed = false;

	if(!progressCallback){
		progressCallback = $.noop;
	}

	var closeLoader = function(){
		if(closed){return;}
		progressCallback(100);
		closed = true;
		setTimeout(function(){
			callback();
		},1200);
	}
	if(preloadImages.length > 0){
		setTimeout(closeLoader,6000);
		preloadImages.each(function(){
			if($(this).is('.js-image-preload')){
				var image_url = $(this).is('image') ? $(this).attr('xlink:href') : $(this).attr('src');
			} else {
				var img_result = /^url\((?:'|")?([a-zA-Z0-9\-\.\:\/\?\&\=\[\]\%\ ]*)(?:'|")?\)$/.exec($(this).css('background-image')),
					image_url = img_result !== null ? img_result[1] : '';
			}
			var image = new Image;
			image.onload = image.onerror = function(){
				numRemaining--;
				progressCallback((preloadImages.length - numRemaining) / preloadImages.length * 100);
				if(numRemaining == 0){
					closeLoader();
				}
			}
			image.src = image_url;

		});
	} else {
		closeLoader();
	}
}